(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-banner"] && !Shopify.designMode) return;
  try {
    
  class ParallaxBannerComponent extends HTMLElement {
    connectedCallback() {
      this.image = this.querySelector('.parallax-banner__image');
      if (!this.image) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reducedMotion.matches) return;

      this.speed = parseFloat(this.dataset.speed) || 0.3;
      this.ticking = false;

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      if (!this.ticking) {
        requestAnimationFrame(() => {
          this.updatePosition();
          this.ticking = false;
        });
        this.ticking = true;
      }
    }

    updatePosition() {
      const rect = this.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      if (rect.bottom < 0 || rect.top > windowHeight) return;

      const progress = (rect.top + rect.height) / (windowHeight + rect.height);
      const offset = (progress - 0.5) * this.speed * rect.height;

      this.image.style.transform = `translate3d(0, ${offset}px, 0)`;
    }
  }

  customElements.define('parallax-banner-component', ParallaxBannerComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  function checkCarouselArrows(section) {
    const slideshow = section.querySelector('.resource-list__carousel slideshow-component');
    if (!slideshow) return;

    const scroller = slideshow.querySelector('slideshow-slides');
    const arrows = slideshow.querySelector('slideshow-arrows');
    if (!scroller || !arrows) return;

    function update() {
      const canScroll = scroller.scrollWidth > scroller.clientWidth + 1;
      arrows.style.display = canScroll ? '' : 'none';
    }

    requestAnimationFrame(() => requestAnimationFrame(update));
    window.addEventListener('resize', update);
  }

  document.querySelectorAll('.section-resource-list--header-arrows').forEach(checkCarouselArrows);

  } catch(e) { console.error(e); }
})();
})();
